import { globalAdminFieldSchemesEntryPoint } from '@jira/admin-pages__field-schemes/entrypoint.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { globalSettingsIssueFieldSchemesConfigRoute } from '@atlassian/jira-router-routes-admin-pages-field-schemes-routes/src/globalSettingsIssueFieldSchemesConfigRoute.tsx';
import { globalSettingsLayout } from '@atlassian/jira-global-settings-layout/src/index.tsx';
import { MENU_ID, SIDEBAR_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarGlobalSettingsIssues from '@atlassian/jira-navigation-apps-sidebar-global-settings-issues/src/async.tsx';
import { expValEquals } from '@atlassian/jira-feature-experiments';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { navigationSidebarGlobalResource } from '@atlassian/jira-router-resources-navigation-sidebar-global/src/index.tsx';
import { conditionalPostOfficeJiraTopBannerResource } from '@atlassian/jira-router-resources-post-office/src/services/index.tsx';
import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';

const pageEntryPoint = createPageEntryPoint({
	main: globalAdminFieldSchemesEntryPoint,
	topNavigationMenuId: MENU_ID.SETTINGS,
});

export const globalSettingsIssueFieldSchemesConfigRouteEntry = createEntry(
	globalSettingsIssueFieldSchemesConfigRoute,
	() => ({
		group: 'global-settings',
		ufoName: 'global-admin.issues.field-schemes',
		layout: globalSettingsLayout,
		navigation: {
			sidebarId: SIDEBAR_ID.GLOBAL_ISSUES_SETTINGS,
			menuId: MENU_ID.SETTINGS,
			sidebar: AsyncSidebarGlobalSettingsIssues,
		},
		canTransitionIn: () => expValEquals('jira_efa_for_cmp_m2_experiment', 'isEnabled', true, false),
		resources: [
			...getNavigationResources(),
			navigationSidebarGlobalResource,
			conditionalPostOfficeJiraTopBannerResource,
		],
		entryPoint: () => {
			if (!expValEquals('jira_efa_for_cmp_m2_experiment', 'isEnabled', true, false)) {
				return undefined;
			}

			return pageEntryPoint;
		},
		meta: {
			reporting: {
				packageName: 'jiraAdminPagesFieldSchemes',
				id: 'globalSettingsIssueFieldSchemes',
				teamName: 'Yamato',
			},
		},
	}),
);
